// react library imports
import React, { useState, useRef, useEffect } from 'react';

// style imports
import './TagInputField.css'; 
import '../Date/Date.css';

const TagInputField = ({ tags, setTags, id, label, notes }) => {
  // set state and ref values
  const [inputValue, setInputValue] = useState('');
  const [focus, setFocus]=useState(false)
  const inputRef = useRef(null);
  const length = tags?.length === 2

  // update the value when initial value changes
  useEffect(()=>{
    if (tags?.length>0) {
      setFocus(true)
    }
  }, [tags])

  // handle onChange event
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // handle enter and backspace for tags
  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue) {
      if (!tags.includes(inputValue)) {
        setTags([...tags, inputValue]);
      }
      setInputValue('');
    }
    if (e.key === 'Backspace' && !inputValue && tags.length) {
      const newTags = [...tags];
      newTags.pop();
      setTags(newTags);
    }
  };

  // handle remove tags from arrays
  const removeTag = (index) => {
    const newTags = [...tags];
    newTags.splice(index, 1);
    setTags(newTags);
  };

  return (
    <div className={`form-input tag-field`} onClick={()=>setFocus(true)}>
      {tags?.map((tag, index) => (
        <div className="tag" key={index}
        onClick={() => removeTag(index)}>
          <h6 className='mues_one_line_clamp'>{tag}</h6>
          <button type="button">
            &times;
          </button>
        </div>
      ))}
      {!length && <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        ref={inputRef}
        placeholder="Type and press enter"
      />}
      <label className={focus ? "form_focus":""} htmlFor={id}>{label} <span>{notes}</span></label>
    </div>
  );
};

export default TagInputField;
